import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableContainer: {
      borderRadius: 0,
    },

    table: {
      '& th:first-child': {
        // borderTopLeftRadius: 16,
      },
      '& th:last-child': {
        borderTopRightRadius: 16,
      },
      '& tr:last-child ': {
        '& td:first-child': { borderBottomLeftRadius: 16 },
        '& td:last-child': { borderBottomRightRadius: 16 },
      },

      '& table': {
        borderRadius: 16,
        marginBottom: 30,
      },
      '& thead': {
        background: '#14171A',
        borderRadius: '16px 16px 0px 0px',
      },
      '& thead th': {
        color: '#fff',
        borderBottom: 'none',
      },
      '& thead tr > *': {
        padding: theme.spacing(1, 2),
      },
      '& tbody tr > *': {
        padding: theme.spacing(0.5, 2),
      },
      '& td': {
        borderBottom: 'none',
      },
      '& tbody tr:nth-of-type(odd) ': {
        background: '#fff',
      },
      '& tbody tr:nth-of-type(even)': {
        background: '#F5F8FA',
      },
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    sortLabel: {
      color: '#fff !important',
    },
    cardCount: {
      display: 'flex',
      background: '#ddd9',
      padding: '10px 15px !important',
      borderRadius: 7,
      margin: theme.spacing(1, 1, 1, 0),
      '&:last-child': {
        marginBottom: 24,
      },
    },
    marginRight: {
      marginRight: theme.spacing(1.5),
    },
    primaryAmount1: {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
    primaryAmount2: {
      color: '#1CBA27',
      fontWeight: 'bold',
    },
    primaryAmount3: {
      color: '#666',
      fontWeight: 'bold',
    },
    secondaryAmount: {
      marginTop: -5,
      color: '#777',
    },
    chip: {
      margin: theme.spacing(0.5),
      marginBottom: 10,
      fontSize: 14,
      fontWeight: 550,
    },
  }),
);

export default useStyles;
